import React from 'react';
import './Pricing.css';
import Reveal from '../shared/Reveal';

export default function Pricing() {
    return (
        <section id='pricing' className='lp-pricing'>
            <div className='lp-section'>
                <div className='lp-wrap'>
                    <Reveal>
                        <p className='lp-eyebrow'>Pricing</p>
                        <h2 className='lp-h2 lp-pricing-claim'>The platform is free.</h2>
                        <p className='lp-lede lp-pricing-lede'>
                            It is early, and it stays free while it grows. What we need from
                            you is feedback: tell us what a swimmer or a coach in your squad
                            actually needs, and we will build that next.
                        </p>
                        <a href='#contact' className='lp-btn lp-pricing-btn'>
                            Send us feedback
                        </a>
                    </Reveal>
                </div>
            </div>
        </section>
    );
}
